<template>
  <div class="about">
    <div>
      <div class="position-relative jp-column">
        <el-image :src="mainBg" class="w-100 title-bg"></el-image>
        <h4 v-if="$i18n.locale !== 'en'" class="jp-en-title">About Us</h4>
        <h1 class="jp-title">{{$t('about.title')}}</h1>
      </div>
    </div>
    <!-- <section class="first-section">
      <div class="company-address"></div>
      <div class="jp-line"></div>
      <div class="jp-column">
        <span class="title">{{$t('about.name')}}</span>
        <el-row :gutter="60" :type="rowType" align="middle">
          <el-col :span="10" :xs="24">
            <img :src="company" alt="" class="t-card w-100">
          </el-col>
          <el-col :span="14" :xs="24">
            <p v-html="$t('about.content')" class="about-introduce"></p>
          </el-col>
        </el-row>
      </div>
    </section> -->
    <section class="first-section special-section">
      <div class="company-address about-bg" :class="{ 'company-address_en': $i18n.locale === 'en' }"></div>
      <div class="jp-line"></div>
      <div class="jp-column">
        <span class="title">
          <div class="jp-line-withit"></div>
          <span class="title-name">{{$t('acti.name')}}</span>
        </span>
        <span class="en-common-title">CNCEC Japan Research Institute</span>
        <el-row :type="rowType" :gutter="gutterType" class="jp-project-content hidden-xs-only" align="middle">
          <el-col :span="21" :xs="24" class="mt-5">
            <el-table
              :data="aboutCompanyData"
              border
              :show-header="false"
              :cell-style="cellstyle"
              style="width: 100%">
              <el-table-column
                prop="lable"
                width="250">
                <template slot-scope="{row}">
                  <div class="table-lable">
                    {{row.lable}}
                  </div>
                  <div class="table-lable table-en">
                    {{row.lableEN}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="name">
                <template slot-scope="{row}">
                  <div :class="{'space-pre-line': row.style}">
                    <div class="table-name" :class="{'table-name-cn': row.style, 'table-name-jp': $i18n.locale === 'jp' && row.style}">
                      {{row.name}}
                    </div>
                    <div class="table-name table-en" :class="{'table-name-en': row.style}">
                      {{row.nameEN}}
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="3" :xs="24">
            <div>
              <img :src="about2" class="image w-100 about3-img">
            </div>
          </el-col>
        </el-row>
        <div class="hidden-sm-and-up">
          <el-row v-for="(about, index) in aboutCompanyData" :key="index" class="about-mobile">
            <el-col>
              <div class="table-lable">
                {{about.lable}}
              </div>
              <div class="table-lable table-en">
                {{about.lableEN}}
              </div>
            </el-col>
            <el-col>
              <div :class="{'space-pre-line': about.style}">
                <div class="table-name" :class="{'table-name-cn': about.style}">
                  {{about.name}}
                </div>
                <div class="table-name table-en" :class="{'table-name-en': about.style}">
                  {{about.nameEN}}
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </section>
    <section class="first-section special-introduction">
      <div class="jp-line introduction"></div>
      <div class="introduction-section">
        <div class="jp-column">
        <span class="title">
          <div class="jp-line-withit"></div>
          <span class="title-name">{{$t('acti.name1')}}</span>
        </span>
          <span class="en-common-title">Organization</span>
          <el-row :gutter="30">
            <el-col :span="12" :xs="24">
              <div class="introduction-content" @click="scrolltoView('#Sites')">
                <div class="introduction-card">
                  <h3>{{$t('acti.name4')}}</h3>
                  <span>Head Office（Yokohama R&D Center）</span>
                </div>
              </div>
            </el-col>
            <el-col :span="12" :xs="24">
              <div class="introduction-content" @click="scrolltoView('#Tsukuba')">
                <div class="introduction-card">
                  <h3>{{$t('acti.name3')}}</h3>
                  <span>Tsukuba R&D Center</span>
                </div>
              </div>
            </el-col>
            <!-- <el-col :span="8" :xs="24">
              <div class="introduction-content" @click="scrolltoView('#Yokohama')">
                <div class="introduction-card">
                  <h3>{{$t('acti.name5')}}</h3>
                  <span>Yokohama R&D Center</span>
                </div>
              </div>
            </el-col> -->
          </el-row>
        </div>
      </div>
    </section>
    <div id="Sites"></div>
    <section class="first-section mobile-sites">
      <div class="company-address about-bg" :class="{ 'company-address_en': $i18n.locale === 'en' }"></div>
      <div class="jp-line"></div>
      <div class="jp-column">
        <span class="title">
          <div class="jp-line-withit"></div>
          <span class="title-name">{{$t('acti.name4')}}</span>
        </span>
        <span class="en-common-title">Head Office（Yokohama R&D Center）</span>
        <el-row :type="rowType" :gutter="gutterType" class="jp-project-content" align="middle">
          <el-col :span="10" :xs="24">
            <div class="jp-overflow-hidden t-card">
              <img :src="about5" class="image w-100 about3-img">
            </div>
          </el-col>
          <el-col :span="14" :xs="24">
            <!-- <p v-html="$t('acti.content')" class="about-introduce"></p> -->
            <div class="about-introduce">
              <div class="d-flex mt-3">
                <b>{{$t('about.local')}}</b><p>{{$t('about.localValue2')}}</p>
              </div>
              <div class="d-flex introduce-en">
                <b>Location</b><p>4F Shibusawa ABC Building No.2，1 Ebisu-cho, Kanagawa-ku, <br>Yokohama-shi, Kanagawa</p>
              </div>
              <div class="d-flex mt-3">
                <b>{{$t('about.tel')}}</b><p>{{$t('about.telValue2')}}</p>
              </div>
              <div class="d-flex introduce-en">
                <b>Tel</b><p>045-620-8845</p>
              </div>
              <div class="d-flex mt-3">
                <b>{{$t('about.fax')}}</b><p>{{$t('about.faxValue2')}}</p>
              </div>
              <div class="d-flex introduce-en">
                <b>Fax</b><p>045-620-8846</p>
              </div>
              <div class="d-flex mt-3">
                <b>{{$t('about.eMail')}}</b><p>{{$t('about.eMailValue2')}}</p>
              </div>
              <div class="d-flex introduce-en">
                <b>E-Mail</b><p>admin@cncec-jri.com</p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </section>
    <div id="Tsukuba"></div>
    <section class="first-section sub-first-section mobile-tsukuba">
      <div class="company-address about-bg" :class="{ 'company-address_en': $i18n.locale === 'en' }"></div>
      <div class="jp-line"></div>
      <div class="jp-column">
        <span class="title">
          <div class="jp-line-withit"></div>
          <span class="title-name">{{$t('acti.name3')}}</span>
        </span>
        <span class="en-common-title">Tsukuba R&D Center</span>
        <el-row :type="rowType" :gutter="gutterType" class="jp-project-content" align="middle">
          <el-col :span="10" :xs="24">
            <div class="jp-overflow-hidden t-card">
              <img :src="about4" class="image w-100 technology-img">
            </div>
          </el-col>
          <el-col :span="14" :xs="24">
            <div class="about-introduce">
              <div class="d-flex mt-3">
                <b>{{$t('about.local')}}</b><p>{{$t('about.localValue1')}}</p>
              </div>
              <div class="d-flex introduce-en">
                <b>Location</b><p>Tokodai 5-9-1, Tsukuba, Ibarakiken</p>
              </div>
              <div class="d-flex mt-3">
                <b>{{$t('about.tel')}}</b><p>{{$t('about.telValue')}}</p>
              </div>
              <div class="d-flex introduce-en">
                <b>Tel</b><p>029-846-3481</p>
              </div>
              <div class="d-flex mt-3">
                <b>{{$t('about.fax')}}</b><p>{{$t('about.faxValue')}}</p>
              </div>
              <div class="d-flex introduce-en">
                <b>Fax</b><p>029-847-4550</p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </section>
    <div id="Yokohama"></div>
    <section class="first-section mobile-yokohama">
      <div class="company-address" :class="{ 'company-address_en': $i18n.locale === 'en' }"></div>
      <!-- <div class="jp-line"></div> -->
      <div class="jp-column">
        <!-- <span class="title">
          <div class="jp-line-withit"></div>
          <span class="title-name">{{$t('acti.name5')}}</span>
        </span> -->
        <!-- <span class="en-common-title">Yokohama R&D Center</span> -->
        <el-row :type="rowType" :gutter="gutterType" class="jp-project-content" align="middle">
          <!-- <el-col :span="24" :xs="24">
            <p>{{$t('common.building')}}</p>
            <p class="en-title">In preparation</p>
          </el-col> -->
        </el-row>
      </div>
    </section>
    <div id="contractUs"></div>
    <div class="jp-column my-3 about-module">
      <el-tabs v-model="activeName">
        <el-tab-pane :label="$t('about.name1')" name="first">
          <section>
            <div class="jp-column">
              <el-timeline class="text-left pl-0">
                <el-timeline-item timestamp="1953" placement="top">
                  <template slot="dot">
                    <div class="parent-dot">
                      <div class="dot1"></div>
                      <div class="dot2"></div>
                      <div class="dot3"></div>
                    </div>
                  </template>
                  <el-card>
                    <p>{{$t('about.developHistory')}}</p>
                    <p class="en-title">CNCEC is originated from the Heavy Industry Design & Construction Company under the former Ministry of Heavy Industry of China.</p>
                  </el-card>
                </el-timeline-item>
                <el-timeline-item timestamp="1984" placement="top">
                  <template slot="dot">
                    <div class="parent-dot">
                      <div class="dot1"></div>
                      <div class="dot2"></div>
                      <div class="dot3"></div>
                    </div>
                  </template>
                  <el-card>
                    <p>{{$t('about.developHistory1')}}</p>
                    <p class="en-title">Registered in Beijing under the name of “China National Chemical Engineering Corporation”.</p>
                  </el-card>
                </el-timeline-item>
                <el-timeline-item timestamp="2005" placement="top">
                  <template slot="dot">
                    <div class="parent-dot">
                      <div class="dot1"></div>
                      <div class="dot2"></div>
                      <div class="dot3"></div>
                    </div>
                  </template>
                  <el-card>
                    <p>{{$t('about.developHistory2')}}</p>
                    <p class="en-title">Renamed as “China National Chemical Engineering Group Corporation”.</p>
                  </el-card>
                </el-timeline-item>
                <el-timeline-item timestamp="2010" placement="top">
                  <template slot="dot">
                    <div class="parent-dot">
                      <div class="dot1"></div>
                      <div class="dot2"></div>
                      <div class="dot3"></div>
                    </div>
                  </template>
                  <el-card>
                    <p>{{$t('about.developHistory3')}}</p>
                    <p class="en-title">Listed at Shanghai Stock Exchange (Stock No.:60117).</p>
                  </el-card>
                </el-timeline-item>
                <el-timeline-item timestamp="2019" placement="top">
                  <template slot="dot">
                    <div class="parent-dot hot">
                      <div class="dot1"></div>
                      <div class="dot2"></div>
                      <div class="dot3"></div>
                    </div>
                  </template>
                  <el-card>
                    <p>{{$t('about.developHistory4')}}</p>
                    <p class="en-title">Released the “Three- and Five-Year Plan, Ten- and Thirty-Year Objective”, listing technology and industry as important development strategies. In the June of the same year, the CNCEC Research Institute and its Japan Branch were registered in Beijing and Tokyo respectively. The latter was named CNCEC Japan Research Institute. </p>
                  </el-card>
                </el-timeline-item>
              </el-timeline>
            </div>
          </section>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { getSecurityCode, sendMessage } from '@/api/websiteApi';

import _ from 'lodash'
import mainBg from '@/assets/img/about_bg.png';
import laboratory1 from '@/assets/img/laboratory1.jpg';
import laboratory2 from '@/assets/img/laboratory2.jpg';
import laboratory3 from '@/assets/img/laboratory3.jpg';
import laboratory4 from '@/assets/img/laboratory4.jpg';
import laboratory5 from '@/assets/img/laboratory5.jpg';
import laboratory6 from '@/assets/img/laboratory6.jpg';
import laboratory7 from '@/assets/img/laboratory7.jpg';
import laboratory8 from '@/assets/img/laboratory8.jpg';
import about1 from '@/assets/img/about1.jpg';
import about2 from '@/assets/img/about2.png';
import about3 from '@/assets/img/about3.jpg';
import about4 from '@/assets/img/about4.jpg';
import about5 from '@/assets/img/about5.png';
export default {
  name: 'about',
  data () {
    return {
      mainBg: mainBg,
      activeName: 'first',
      loading: false,
      collapseActiveName: '',
      rowType: '',
      gutterType: '',
      formMessage: {},
      securityCodeData: {},
      laboratory1: laboratory1,
      laboratory2: laboratory2,
      laboratory3: laboratory3,
      laboratory4: laboratory4,
      laboratory5: laboratory5,
      laboratory6: laboratory6,
      laboratory7: laboratory7,
      laboratory8: laboratory8,
      about1: about1,
      about2: about2,
      about3: about3,
      about4: about4,
      about5: about5,
      formRules: {
        nameSurname: [{ required: true, message: this.$t('common.pleaseEnterContent'), trigger: 'change' }],
        eMail: [{ required: true, message: this.$t('common.pleaseEnterContent'), trigger: 'change' }],
        companyName: [{ required: true, message: this.$t('common.pleaseEnterContent'), trigger: 'change' }],
        // telephone: [{ required: true, validator: validatePhone, trigger: 'change' }],
        content: [{ required: true, message: this.$t('common.pleaseEnterContent'), trigger: 'change' }],
        securityCode: [{ required: true, message: this.$t('common.pleaseEnterSecurityCode'), trigger: 'change' }],
      },
      aboutCompanyData: [],
      aboutCompany: [
        {
          lable: this.$t('about.lable1'),
          lableEN: 'Company name',
          name: this.$t('about.tablename1'),
          nameEN: 'CNCEC Japan Research Institute'
        },{
          lable: this.$t('about.lable2'),
          lableEN: 'Headquarters in Tokyo',
          name: this.$t('about.tablename2'),
          nameEN: '4F Shibusawa ABC Building No.2，1 Ebisu-cho, Kanagawa-ku, Yokohama-shi, Kanagawa'
        },{
          lable: this.$t('about.lable3'),
          lableEN: 'Legal representative',
          name: this.$t('about.tablename3'),
          nameEN: 'Chairman and General Manager Gao Xiaofang'
        },{
          lable: this.$t('about.lable4'),
          lableEN: 'Established in',
          name: this.$t('about.tablename4'),
          nameEN: 'June 18, 2019'
        },{
          lable: this.$t('about.lable5'),
          lableEN: 'Registered capital',
          name: this.$t('about.tablename5'),
          nameEN: '490 Million Yen'
        },{
          lable: this.$t('about.lable6'),
          lableEN: 'Shareholders (n)',
          name: this.$t('about.tablename6'),
          nameEN: 'One (By the end of March 2022）'
        },{
          lable: this.$t('about.lable7'),
          lableEN: 'Parent Company',
          name: this.$t('about.tablename7'),
          nameEN: 'China National Chemical Engineering Group Corporation Ltd.'
        },{
          lable: this.$t('about.lable8'),
          lableEN: 'The number of employees',
          name: this.$t('about.tablename8'),
          nameEN: '50 (As of 2022)'
        },{
          style: true,
          lable: this.$t('about.lable9'),
          lableEN: 'Business content',
          name: this.$t('about.tablename9'),
          nameEN: '1. Technology development and research in chemistry, materials, energy, environmental protection, health, and other fields; \n' + 
                '2. Promoting technology and products, providing technical consultation, and transferring technological achievements in the above fields; \n' + 
                '3. Import and export of products in the above fields (including dangerous chemicals); \n' + 
                '4. Investment and M&A activities in the above fields;'
        },{
          lable: this.$t('about.lable10'),
          lableEN: 'Major tradingtransaction \n' +
          'banks',
          name: this.$t('about.tablename10'),
          nameEN: 'Sumida Mitsui Banking Corporation; \n China Construction Bank'
        }
      ]
    }
  },
  watch: {
    '$i18n.locale': {
      handler() {
        this.aboutCompanyData = [];
        this.$nextTick(() => {
          _.forEach(this.aboutCompany, (item, index) => {
            item.lable = this.$t('about.lable' + (index + 1));
            item.name = this.$t('about.tablename' + (index + 1))
            this.aboutCompanyData.push(item);
          })
          this.$forceUpdate();
        })
      }
    }
  },
  created() {
    this.aboutCompanyData = this.aboutCompany;
    this.getWidth();
    // this.refreshSecurityCode()  // 获取验证码
    this.$nextTick(() => {
      if (this.$route.params && this.$route.params.type === 'fifth') {
        this.activeName = this.$route.params.type;
        setTimeout(() => {
          this.$el.querySelector('#contractUs').scrollIntoView({ block: 'start', behavior: 'smooth' });
        }, 300)
      }
    })
  },
  methods: {
    cellstyle({row, column, rowIndex, columnIndex}) {
      let stylejson = {};
      stylejson.fontSize = '19px';
      if (columnIndex === 0) {
        stylejson.background = '#dbdbdb';
      }
      return stylejson;
    },
    getWidth() {
      let width = `${document.documentElement.clientWidth}`;
      if (width < 992) {
        this.rowType = ''
        this.gutterType = 0
      } else {
        this.rowType = 'flex'
        this.gutterType = 60
      }
    },
    refreshSecurityCode() {
      getSecurityCode().then(res => {
        res.imageContent = "data:image/png;base64," + res.imageContent;
        this.securityCodeData = res;
      })
    },
    scrolltoView(id) {
      this.$el.querySelector(id).scrollIntoView({ block: 'start', behavior: 'smooth' });
    },
    onSubmit() {
      this.loading = true;
      this.formMessage.securityId = this.securityCodeData.securityId;
      this.$refs['formMessage'].validate((valid) => {
        if (valid) {
          sendMessage(this.formMessage).then(res => {
            this.$message({
              message: this.$t('common.submitSuccess'),
              type: 'success'
            });
            this.loading = false;
          }).catch(error => {
            this.$message.error(this.$t('common.verificationCodeError'));
            this.loading = false;
          })
        } else {
          this.loading = false;
        }
      });
    },
    moreOrganizational() {
      this.$router.push({ name: 'organizational' });
    },
    handleClick() {}
  }
}
</script>



// WEBPACK FOOTER //
// src/view/about.vue